import { useEffect } from 'react';

const useScript = (url) => {
    useEffect(() => {
        if (!window.tailwindConfigInjected) {
            const configScript = document.createElement('script');
            configScript.innerHTML = `tailwind.config = { darkMode: 'class', theme: { extend: { animation: { 'spin-slow': 'spin 3s linear infinite' } } } }`;
            document.head.appendChild(configScript);
            window.tailwindConfigInjected = true;
        }
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return () => { document.body.removeChild(script); }
    }, [url]);
};

export default useScript;
